// src/config.js

const isProduction = process.env.NODE_ENV === 'production';
const isStaging = process.env.REACT_APP_ENV === 'staging';


//staging settings and cofiguration

export const API_BASE_URL = isStaging
  ? "https://alfresko-api-staging-122644801614.europe-west2.run.app/api"
  : isProduction
  ? "https://alfresko-api-122644801614.europe-west2.run.app/api"
  : "http://localhost:5195/api";

export const FRONTEND_BASE_URL = isStaging
  ? "https://staging.admin.alfresko.co.uk"
  : isProduction
  ? "https://admin.alfresko.co.uk"
  : "http://localhost:3000";
// ============================================================================
// COMPLETE API ENDPOINTS
// ============================================================================
export const ENDPOINTS = {

// ===== ACCESSORIES =====
ACCESSORIES: `${API_BASE_URL}/Accessory`,
ACCESSORY_BY_ID: (id) => `${API_BASE_URL}/Accessory/${id}`, // GET, PUT

// ===== ADMIN =====
ADMIN: {
    BASE_PRICES: `${API_BASE_URL}/Admin/baseprices`, // GET
    BASE_PRICE: (id) => `${API_BASE_URL}/Admin/baseprice/${id}`, // PATCH
    BASE_PRICES_BULK: `${API_BASE_URL}/Admin/baseprices/bulk`, // PATCH
    WALL_PRICES: `${API_BASE_URL}/Admin/wallprices`, // GET
    WALL_PRICE: (id) => `${API_BASE_URL}/Admin/wallprice/${id}`, // PATCH
    ACCESSORIES: `${API_BASE_URL}/Admin/accessories`, // GET
    ACCESSORY: (id) => `${API_BASE_URL}/Admin/accessory/${id}`, // PATCH
},

// ===== AUTH =====
AUTH: {
    REGISTER: `${API_BASE_URL}/Auth/register`, // POST
    LOGIN: `${API_BASE_URL}/Auth/login`, // POST
    CHANGE_PASSWORD: `${API_BASE_URL}/Auth/change-password`, // POST
    RESET_PASSWORD_REQUEST: `${API_BASE_URL}/Auth/reset-password/request`, // POST
    RESET_PASSWORD_CONFIRM: `${API_BASE_URL}/Auth/reset-password/confirm`, // POST
    FORGOT_PASSWORD: `${API_BASE_URL}/Auth/forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}/Auth/reset-password`,
},

// ===== CANOPIES =====
CANOPIES: `${API_BASE_URL}/Canopy`, // GET, POST
CANOPY_BY_ID: (id) => `${API_BASE_URL}/Canopy/${id}`, // GET, PUT, DELETE

// ===== COMPONENTS (V2) =====
COMPONENTS: {
    WALLS: `${API_BASE_URL}/v2/components/walls`, // GET
    ROOFS: `${API_BASE_URL}/v2/components/roofs`, // GET
    CANOPIES: `${API_BASE_URL}/v2/components/canopies`, // GET
    WALL_BY_ID: (id) => `${API_BASE_URL}/v2/components/walls/${id}`, // GET
    ROOF_BY_ID: (id) => `${API_BASE_URL}/v2/components/roofs/${id}`, // GET
    CANOPY_BY_ID: (id) => `${API_BASE_URL}/v2/components/canopies/${id}`, // GET
},

// ===== DEALER =====
DEALER: {
    PROFILE: `${API_BASE_URL}/Dealer/profile`, // GET, PUT
    PROFILE_LOGO: `${API_BASE_URL}/Dealer/logo`, // POST
},

// ===== DEALER PORTAL =====
DEALER_PORTAL: {
    MY_QUOTES: `${API_BASE_URL}/DealerPortal/my-quotes`, // GET
},

// ===== PRICES (V2 ADMIN) =====
PRICES: {
    ACCESSORIES: `${API_BASE_URL}/v2/admin/prices/accessories`, // GET
    ACCESSORY_BY_ID: (id) => `${API_BASE_URL}/v2/admin/prices/accessories/${id}`, // GET
},

// ===== PUBLIC DEALERS =====
PUBLIC_DEALERS: {
    BY_ID: (id) => `${API_BASE_URL}/public/dealers/${id}`, // GET
},

// ===== QUOTES (V2) =====
QUOTES: `${API_BASE_URL}/v2/quotes`, // POST
QUOTE_BY_ID: (id) => `${API_BASE_URL}/v2/quotes/${id}`, // PATCH, DELETE
MANUAL_QUOTES: `${API_BASE_URL}/v2/quotes/manual`, // GET, POST

// ===== ROOFS =====
ROOFS: `${API_BASE_URL}/Roof`, // GET, POST
ROOF_BY_ID: (id) => `${API_BASE_URL}/Roof/${id}`, // GET, PUT, DELETE

// ===== SURVEYS =====
SURVEYS: `${API_BASE_URL}/Surveys`, // GET, POST
SURVEY_BY_ID: (id) => `${API_BASE_URL}/Surveys/${id}`, // GET
SURVEY_PUBLIC: (token) => `${API_BASE_URL}/Surveys/public/${token}`, // GET
SURVEY_RESPONSES_BY_ID: (surveyId) => `${API_BASE_URL}/surveys/${surveyId}/responses`, // GET

// ===== SURVEY RESPONSES =====
SURVEY_RESPONSES: (publicToken) => `${API_BASE_URL}/surveys/${publicToken}/responses`, // POST (multipart/form-data)

// ===== TEST ENDPOINTS =====
TEST: {
    PUBLIC: `${API_BASE_URL}/Test/public`, // GET
    SECURE: `${API_BASE_URL}/Test/secure`, // GET
},

// ===== USER MANAGEMENT =====
USER_MANAGEMENT: {
    USERS: `${API_BASE_URL}/UserManagement/users`, // GET
    PROMOTE: (userId) => `${API_BASE_URL}/UserManagement/promote/${userId}`, // POST
    DEMOTE: (userId) => `${API_BASE_URL}/UserManagement/demote/${userId}`, // POST
    INVITE_USER: `${API_BASE_URL}/UserManagement/users/invite`,
    ME: `${API_BASE_URL}/UserManagement/me`, // GET
    INITIALIZE_ROLES: `${API_BASE_URL}/UserManagement/initialize-roles`, // POST
},

// ===== WALLS =====
WALLS: `${API_BASE_URL}/Wall`, // GET, POST
WALL_BY_ID: (id) => `${API_BASE_URL}/Wall/${id}`, // GET, PUT, DELETE
};
export const getAuthHeaders = () => {
const token = localStorage.getItem('authToken');
return {
'Content-Type': 'application/json',
'Authorization': `Bearer ${token}`  
};
};